import wrapURL from '@/components/bloodDraw/BloodDrawData/interceptors.js';

export const orderBaseURL = wrapURL(
    process.env.VUE_APP_ENV=='production' 
    // 04/08/2025: Fangyuan asked to replace the cloud production order endpoint to be the local version due to different catche of blood concierge
    // 04/30/2026: VIB-1709 Replace the local production order endpoint to be the cloud version
    ? 'https://api.vibrant-wellness.com/v1/portal/order' // production
    // ? 'https://api.vibrant-wellness.com/v1/portal/order' // cloud production
    :'https://api.vibrant-wellness.com/v1/portal/order/staging' //staging cloud endpoint
    // :'https://lis.vibrant-america.com/staging/order'
);

export const pricingBaseURL = wrapURL(
    process.env.VUE_APP_ENV=='production' 
    // 04/08/2025 VIB-892: Rui deprecated the previous order API, rewrite it to be new ones
    ? 'https://api.vibrant-wellness.com/v1/pricing' // cloud production
    :'https://api.vibrant-wellness.com/v1/pricing/staging' //staging cloud endpoint
);
